import { useTranslate } from "@similarweb/i18n-provider";

import { useAccessibleItems } from "app/components/React/QuickSearch/pageData/useAccessibleItems";
import { useRecentQuery } from "app/components/React/QuickSearch/queries/useRecentQuery";
import type { Recent } from "app/custom-hooks/useRecentsHook";
import { useMount } from "app/custom-hooks/useMount";
import { MAX_RECENTS } from "app/pages/activation/components/HomeWithData/constants";
import { RecentKeywordItem } from "app/pages/activation/components/HomeWithData/RecentActivity/RecentKeywordItem";
import { RecentWebsiteItem } from "app/pages/activation/components/HomeWithData/RecentActivity/RecentWebsiteItem";
import { SectionTitle } from "app/pages/activation/components/HomeWithData/SectionTitle";
import { RECENTS_TITLE } from "app/pages/activation/components/HomeWithData/texts";

import { recentActivityDataAutomation } from "../dataAutomationKeys";

import * as SC from "./styles";

const getRecentUiRouterState = (recent: Recent): string | undefined => recent.data.stateName;

export const RecentActivity = () => {
    const { recents, isRecentLoading, refetch } = useRecentQuery(["website", "keyword"]);
    const { translate } = useTranslate();

    useMount(() => void refetch());

    const accessibleRecents = useAccessibleItems(recents, getRecentUiRouterState);

    if (!accessibleRecents.length || isRecentLoading) {
        return null;
    }

    const recentsData = accessibleRecents.slice(0, MAX_RECENTS);

    return (
        <SC.Container data-automation={recentActivityDataAutomation.container}>
            <SectionTitle
                title={translate(RECENTS_TITLE)}
                dataAutomation={recentActivityDataAutomation.title}
            />

            <SC.RecentsContainer data-automation={recentActivityDataAutomation.itemsContainer}>
                {recentsData.map(({ item, isLocked }) =>
                    item.data.type === "website" ? (
                        <RecentWebsiteItem
                            item={item}
                            isLocked={isLocked}
                            key={item.id}
                        />
                    ) : (
                        <RecentKeywordItem
                            item={item}
                            isLocked={isLocked}
                            key={item.id}
                        />
                    ),
                )}
            </SC.RecentsContainer>
        </SC.Container>
    );
};
